import { SVGProps } from "react";

type CubeTimeProps = SVGProps<SVGSVGElement> & {
  strokeColor?: string;
  fillColor?: string;
};

export function CubeTime({
  strokeColor = "currentColor",
  fillColor = "currentColor",
  ...props
}: CubeTimeProps) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.984 8.09V6.245a2.59 2.59 0 0 0-.323-1.261 2.418 2.418 0 0 0-.884-.914l-4.703-2.756A2.257 2.257 0 0 0 8.93 1c-.4 0-.794.108-1.144.313L3.083 4.068a2.418 2.418 0 0 0-.885.915 2.59 2.59 0 0 0-.322 1.261v5.345c-.001.443.11.879.323 1.261.212.383.517.698.884.914l4.703 2.756c.35.206.744.313 1.144.313.4 0 .794-.107 1.144-.313l1.99-1.167M15.506 4.747 8.93 8.917m0 0-6.576-4.17m6.576 4.17v7.908"
      />
      <path
        fill={fillColor}
        d="M15.025 10.492h-.356a.061.061 0 0 0-.06.063v2.15c0 .02.01.04.025.051l1.223.943c.027.02.064.015.083-.013l.212-.305a.064.064 0 0 0-.013-.087l-1.055-.806v-1.933a.061.061 0 0 0-.06-.063Zm1.626.588 1.161.299c.037.01.073-.02.073-.06l.006-1.262c0-.052-.057-.082-.095-.05l-1.167.963a.062.062 0 0 0-.02.027.066.066 0 0 0 .014.066.059.059 0 0 0 .028.017Zm1.242 2.352-.42-.152a.056.056 0 0 0-.045.002.061.061 0 0 0-.03.035l-.044.118c-.132.33-.32.625-.562.88a2.61 2.61 0 0 1-.833.592 2.488 2.488 0 0 1-2.038 0 2.609 2.609 0 0 1-.832-.593c-.241-.254-.43-.55-.562-.879a2.896 2.896 0 0 1-.205-1.076c0-.373.07-.736.206-1.076.132-.33.32-.625.562-.88.239-.252.521-.453.833-.592a2.467 2.467 0 0 1 1.018-.217c.354 0 .696.072 1.02.217a2.611 2.611 0 0 1 1.043.845l.443-.365C16.865 9.505 15.958 8.999 14.94 9c-1.774 0-3.198 1.521-3.18 3.394.018 1.84 1.435 3.325 3.181 3.325 1.373 0 2.542-.919 2.988-2.206a.065.065 0 0 0-.036-.081Z"
      />
    </svg>
  );
}
